import React, { useState } from 'react';
import { Palette, Check, Sun, Moon, Layout } from 'lucide-react';
import { useTheme } from '../../../theme/ThemeContext';
import { SettingsSection } from '../SettingsUIComponents';

const ThemePreview = ({ theme }) => <div className={`settings-theme-mini settings-theme-mini-${theme}`} aria-hidden="true">
  <div className="settings-mini-toolbar"><i /><i /><i /></div>
  <div className="settings-mini-layout"><div className="settings-mini-sidebar"><b /><b /><b /></div><div className="settings-mini-body"><i /><span><b /><b /><b /></span></div></div>
</div>;

const ThemeSettings = () => {
  const { currentTheme, setTheme } = useTheme();
  const [checked, setChecked] = useState(true);
  const options = [
    { id: 'light', name: 'Light Theme', description: 'The original clean and bright look.', icon: Sun },
    { id: 'dark', name: 'Dark Theme', description: 'Easy on the eyes for low light environments.', icon: Moon },
    { id: 'standard', name: 'Standard Theme', description: 'A neutral, professional slate appearance.', icon: Layout }
  ];
  return <SettingsSection icon={Palette} title="Theme Customization" description="Choose the appearance that works best for you. These settings will be applied across all pages.">
    <div className="settings-theme-options">{options.map(option => {
      const Icon = option.icon;
      return <button type="button" key={option.id} onClick={() => setTheme(option.id)} aria-pressed={currentTheme === option.id} className={`settings-theme-option ${currentTheme === option.id ? 'is-selected' : ''}`}>
        <div className="settings-theme-option-heading"><Icon size={19} /><div><h3>{option.name}</h3><p>{option.description}</p></div><span className="settings-theme-check">{currentTheme === option.id && <Check size={13} />}</span></div>
        <ThemePreview theme={option.id} />
      </button>;
    })}</div>
    <h3 className="settings-preview-title">Preview Components</h3>
    <div className="settings-theme-components">
      <div><h4>Cards and Buttons</h4><div className="settings-preview-surface"><div className="settings-sample-card"><h5>Sample Card</h5><p>This is how your cards and text will look in the selected theme.</p></div><div className="settings-preview-buttons"><button type="button" className="settings-outline-button">Secondary</button><button type="button" className="settings-primary-button">Primary</button></div></div></div>
      <div><h4>Form Elements</h4><div className="settings-preview-surface"><label htmlFor="settings-preview-input">Input Field</label><input id="settings-preview-input" placeholder="Sample input text" /><label className="settings-preview-checkbox"><input type="checkbox" checked={checked} onChange={e => setChecked(e.target.checked)} /> Checkbox example</label></div></div>
    </div>
  </SettingsSection>;
};
export default ThemeSettings;
